import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { SicotService } from './sicot.service';

@Injectable({
  providedIn: 'root'
})
export class Mirko3Service {



  constructor(private http: HttpClient, private siCOTService: SicotService) { }

  getQualifiche(): Observable<any[]> {
    return this.http.get<any[]>(this.siCOTService.API_ENDPOINT_COT_SERVICE + '/qualifiche');
  }
  getDisponibilitaUVM(body: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.siCOTService.API_ENDPOINT_COT_SERVICE + '/uvm-disponibilita-test',
      body
    );
  }




  updateStatoRichiestaSessioneUVM(idRichiesta: any, cotDisponibilita: any): Observable<any> {

    const body = new RichiestaId();
    body.richiestaId = idRichiesta;
    body.cotDisponibilita = cotDisponibilita;
    body.wso2Sub = this.siCOTService.getUserId() ?? undefined;

    const headers = {
      'Content-Type': 'application/json',
    }



    return this.http.post<any>(this.siCOTService.API_ENDPOINT_COT_SERVICE + '/flow-manager/update', body, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    });

  }

}

class RichiestaId {
  richiestaId: string | undefined;
  cotDisponibilita: any | undefined;
  wso2Sub?: string;
}
